// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #0D1723;
    padding: 14px 28px;
    color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    font-family: 'Arial', sans-serif;
  }

  .navbar-main {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.navbar-main img{
  margin-top: 10px;
  width: 8rem;
  height: 2.5rem;
}
  .navbar-logo {
    width: 120px;
    cursor: pointer;
  }
  
  .navbar-option {
    display: flex;
    gap: 20px;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  
  .navbar-option li {
    font-size: 16px;
    font-weight: 500;
  }
  
  .navbar-option a {
    text-decoration: none;
    color: rgb(170, 170, 170);
    transition: color 0.3s;
  }
  
  .navbar-option a:hover {
    color: #007bff;
  }
  
  .navbar-actions {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  
  .navbar-search {
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.3s;
  }
  
  .navbar-search:focus {
    border-color: #007bff;
  }
  
  .navbar-logout {
    padding: 8px 16px;
    background-color: #ff4d4d;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .navbar-logout:hover {
    background-color: #a31b1b;
  }
  /* Modal overlay */
  .navbar-main .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* Modal content */
.navbar-main .modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: 300px;
}

.navbar-main .modal-content h2 {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
}

.navbar-main .modal-buttons {
  column-gap: 20px;
  display: flex;
  justify-content: center;
}

.confirm-button {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-button {
  background-color: #f44336;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.confirm-button:hover,
.cancel-button:hover {
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,gCAAgC;EAClC;;EAEA;EACA,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;EACA,kBAAkB;EAClB;EACA,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,YAAY;AACd","sourcesContent":[".navbar-main {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #0D1723;\n    padding: 14px 28px;\n    color: white;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    font-family: 'Arial', sans-serif;\n  }\n\n  .navbar-main {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1000;\n}\n\n.navbar-main img{\n  margin-top: 10px;\n  width: 8rem;\n  height: 2.5rem;\n}\n  .navbar-logo {\n    width: 120px;\n    cursor: pointer;\n  }\n  \n  .navbar-option {\n    display: flex;\n    gap: 20px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n  \n  .navbar-option li {\n    font-size: 16px;\n    font-weight: 500;\n  }\n  \n  .navbar-option a {\n    text-decoration: none;\n    color: rgb(170, 170, 170);\n    transition: color 0.3s;\n  }\n  \n  .navbar-option a:hover {\n    color: #007bff;\n  }\n  \n  .navbar-actions {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n  \n  .navbar-search {\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.3s;\n  }\n  \n  .navbar-search:focus {\n    border-color: #007bff;\n  }\n  \n  .navbar-logout {\n    padding: 8px 16px;\n    background-color: #ff4d4d;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n  \n  .navbar-logout:hover {\n    background-color: #a31b1b;\n  }\n  /* Modal overlay */\n  .navbar-main .modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n/* Modal content */\n.navbar-main .modal-content {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  text-align: center;\n  width: 300px;\n}\n\n.navbar-main .modal-content h2 {\n  margin-bottom: 20px;\n  font-size: 18px;\n  color: #333;\n}\n\n.navbar-main .modal-buttons {\n  column-gap: 20px;\n  display: flex;\n  justify-content: center;\n}\n\n.confirm-button {\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.cancel-button {\n  background-color: #f44336;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.confirm-button:hover,\n.cancel-button:hover {\n  opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
